import * as Yup from 'yup';

export const registroSchemaUsuarios = Yup.object({
    nombre: Yup.string()
        .required("Campo requerido.")
        .min(2, "2 caracteres mínimo.")
        .max(30, "30 caracteres máximo."),
    apellido: Yup.string()
        .required("Campo requerido.")
        .min(2, "2 caracteres mínimo.")
        .max(30, "30 caracteres máximo."),
    email: Yup.string()
        .required("Campo requerido.")
        .email("Correo electronico invalido.")
        .max(30, "30 caracteres máximo."),
    password: Yup.string()
        .required("Campo requerido.")
        .min(8, "8 caracteres mínimo."),
})